import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {ButtonComponent} from "../../../shared-module/components/button/button.component";
import {RouterLink} from "@angular/router";
import {DatePipe} from "@angular/common";
import {AuthService} from "../../../shared-module/services/auth.service";
import Relation from "../../../shared-module/model/relation.model";
import {BadgeComponent} from "../../../shared-module/components/badge/badge.component";
import {Ticket} from "../../../shared-module/model/ticket.model";
import {TicketStateLabel} from "../../../shared-module/enums/ticket-state-label";
import {ApplicationConfig, config} from "../../../../config";
import {NotFoundComponent} from "../../../shared-module/components/not-found/not-found.component";
import {CardComponent} from "../../../shared-module/components/card/card.component";

@Component({
    imports: [
    ButtonComponent,
    RouterLink,
    BadgeComponent,
    DatePipe,
    NotFoundComponent,
    CardComponent
],
    templateUrl: './tickets.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './tickets.component.scss'
})
export class TicketsComponent {
  private readonly authService: AuthService = inject(AuthService);
  public tickets: Ticket[] = [];

  protected relation: Relation | null = null;
  protected readonly config: ApplicationConfig = config;
  protected readonly TicketStateLabel: Record<string, string> = TicketStateLabel;

  constructor() {
    this.authService.getUser(['relations.tickets']).subscribe();

    this.authService.getActiveRelation().subscribe((relation: Relation | null): void => {
      if (!relation || !relation?.tickets) {
        return;
      }
      this.tickets = [...relation.tickets].sort((a: Ticket, b: Ticket) => {
        return a.updated_at > b.updated_at ? -1 : 1;
      });
    });
  }

  // Method to count tickets with combined states 'new' or 'pending'
  protected getOpenTickets(): Ticket[] {
    return this.tickets.filter((ticket: Ticket) =>
      ticket.state_description === 'new' || ticket.state_description === 'pending'
    );
  }
}
